import { VirtualKeyboardService } from './virtualKeyboard.service';
import { Component, Input, OnInit, ElementRef, Optional, Self, Renderer2, AfterViewInit, OnDestroy } from '@angular/core';
import { NgControl, FormControl, AbstractControl } from '@angular/forms';
import { Subject, Subscription, takeUntil } from 'rxjs';

@Component({
    selector: 'app-virtual-keyboard',
    templateUrl: './virtual-keyboard.component.html',
    styleUrls: ['./virtual-keyboard.component.scss'],
    standalone: false
})
export class VirtualKeyboardComponent implements OnDestroy {
  @Input() inputElement?: HTMLInputElement;
  @Input() control: AbstractControl | null = null;
  destroy = new Subject<void>();
  sub?: Subscription;

  constructor(private virtualKeyboard: VirtualKeyboardService) {

  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }

  toggleKeyboard() {
    if (this.sub) {
      this.virtualKeyboard.close();
      this.sub?.unsubscribe();
      this.sub = undefined;
    }
    else {
      this.virtualKeyboard.open(this.control?.value || this.inputElement?.value || '');

      this.sub = this.virtualKeyboard.changed!
        .pipe(
          takeUntil(this.destroy)
        )
        .subscribe({
          next: (value: string) => {
            if (this.inputElement) {
              this.inputElement.value = value;
            }
            if (this.control instanceof FormControl) {
              this.control.setValue(value);
            } else if (this.control && this.control instanceof NgControl) {
              this.control.control?.setValue(value);
            }
          },
          complete: () => this.sub = undefined
        });
    }
  }
}
